import api, { addAuthToData } from './api';

export const adminService = {
  // Create admin
  createAdmin: async (userData) => {
    try {
      const dataWithAuth = addAuthToData(userData);
      const response = await api.post('/api.php?module=admin&action=create', dataWithAuth);
      return response.data;
    } catch (error) {
      throw error.response?.data || { success: false, message: 'Network error' };
    }
  },

  // Login admin
  login: async (credentials) => {
    try {
      const response = await api.post('/api.php?module=admin&action=login', credentials);
      if (response.data.success) {
        // Store user data in localStorage
        localStorage.setItem('adminUser', JSON.stringify(response.data));
        localStorage.setItem('adminToken', response.data.user_id.toString());
      }
      return response.data;
    } catch (error) {
      throw error.response?.data || { success: false, message: 'Network error' };
    }
  },

  // Get all admins
  getAdmins: async () => {
    try {
      const dataWithAuth = addAuthToData({});
      const response = await api.post('/api.php?module=admin&action=read', dataWithAuth);
      return response.data;
    } catch (error) {
      throw error.response?.data || { success: false, message: 'Network error' };
    }
  },

  // Get single admin
  getAdmin: async (id) => {
    try {
      const dataWithAuth = addAuthToData({ id });
      const response = await api.post('/api.php?module=admin&action=read', dataWithAuth);
      return response.data;
    } catch (error) {
      throw error.response?.data || { success: false, message: 'Network error' };
    }
  },

  // Logout
  logout: () => {
    localStorage.removeItem('adminUser');
    localStorage.removeItem('adminToken');
  },

  // Check if user is authenticated
  isAuthenticated: () => {
    return !!localStorage.getItem('adminToken');
  },

  // Get current user
  getCurrentUser: () => {
    const user = localStorage.getItem('adminUser');
    return user ? JSON.parse(user) : null;
  }
};